import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchRepairReportDetail } from '#/api/aftersalesMgmt/repairReport/fetchDetail';
import { ROUTES } from '#/config/routes';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import RepairReportBlock from '#/modules/crmMgmt/aftersales/repairReport/components/RepairReportBlock';
import {
  getRepairReportApiErrorMessage,
} from '#/modules/crmMgmt/aftersales/repairReport/helper/apiError';
import PageShell from '#/modules/infra/layout/PageShell';
import { repairReportDetailQueryKey } from '#/utils/queryKeys';

const RepairReportDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: repairReportDetailQueryKey(id),
    queryFn: () => fetchRepairReportDetail(id),
    enabled: Boolean(id),
    retry: false,
  });

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">維修報告詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.repairReport}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getRepairReportApiErrorMessage(detailQuery.error, '載入維修報告失敗')}
            </p>
          ) : null}

          {detail ? (
            <RepairReportBlock
              detail={detail}
              showActions
              onRefetch={() => detailQuery.refetch()}
            />
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default RepairReportDetailPage;
